import jsPDF from "jspdf";

export const addDisclaimer = (pdf: jsPDF, startY: number) => {
  const disclaimerTitle = `Disclaimer:`;
  const disclaimerCondition = `Condition:`;
  const disclaimerText = `
    * The information used to calculate your pool heating requirement is only an estimate and guide only which based on information provided by you ("The Customer").
    * This sizing guide is indicative only and non-contractual. For a detailed analysis specific to your address, contact your local Davey dealer.
    * Therefore, any under or over sizing of the heater for your pool heating requirements is not the responsibility of Davey Water Products.
    * Davey Water Products will not be held responsible for installation by your installer or running cost of your heater as a result of selecting the recommended model.
    * The pool heat pump sizing calculation is based on a maximum set temperature. At initial cold water start up the heat pump may need to run for a longer period per day to reach the set temperature.
    * This calculator is optimised for day time heat pump operation at 26C ambient air temperature.
    * Operation in low ambient temperatures, windy locations and pool water features will require additional heating capacity which may require a larger size pool heat pump.
    * Sizing a pool heat pump in cooler locations requiring winter season heating should be achieved at a maximum of 8 hours daytime operation.
    * When pool cover is used, this calculation assumes the use of a pool cover while heating the pool in order to meet expectations when maintaining temperature, reaching initial heat up time and calculating estimated cost of usage.
    * Average Costs are indicative only.
    * Dollar values have been rounded to the nearest dollar.
    * Volume calculation is adjusted based on pool material (Slope side for Fibre glass and Liner material, Straight side for concrete material).
    * This calculator does not applicable for infinity pool. Please contact Davey Support team for further enquiries.`;

  pdf.setFillColor(240, 240, 240); 
  const disclaimerHeight = pdf.getTextDimensions(disclaimerText, {
    maxWidth: 210,
  }).h;
  pdf.rect(0, startY, 210, disclaimerHeight - 60, "F"); 

  pdf.setFontSize(6);
  pdf.setTextColor(0);
  pdf.setFont("NotoSans-Bold", "normal");
  pdf.text(disclaimerTitle, 15, startY + 10);
  pdf.setFontSize(6);
  pdf.setTextColor(0);
  pdf.text(disclaimerCondition, 15, startY + 15);

  pdf.setFont("NotoSans-Regular", "normal");
  pdf.text(disclaimerText, 15, startY + 16, { maxWidth: 180 });
};
